"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _Logger = _interopRequireDefault(require("../../util/Logger"));

var _AppStore = _interopRequireDefault(require("../store/AppStore"));

var _config = _interopRequireDefault(require("../../config"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Api = /*#__PURE__*/function () {
  function Api() {
    _classCallCheck(this, Api);
  }

  _createClass(Api, null, [{
    key: "getBaseUrl",
    value: function getBaseUrl() {
      if (_config["default"].env === 'live') {
        return _config["default"].url;
      }

      return _config["default"].url;
    }
  }, {
    key: "call",
    value: function call(method) {
      var _this = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var onProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var authToken = _AppStore["default"].getState().auth.token || null;
      var requestUrl = this.getBaseUrl() + method;
      var ajaxOptions = {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        contentType: 'application/json',
        body: JSON.stringify(data)
      };

      if (authToken !== null) {
        ajaxOptions.headers['Authorization'] = 'Bearer ' + authToken;
      }

      _Logger["default"].log('api options', requestUrl, ajaxOptions);

      _Logger["default"].log('api request', requestUrl, data);

      return new Promise(function (resolve, reject) {
        // const config =  {
        //   onUploadProgress: function(progressEvent: any) {
        //     var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
        //   }
        // }
        (0, _axios["default"])({
          url: _this.getBaseUrl() + method,
          method: 'POST',
          // contentType: 'application/json',
          headers: ajaxOptions['headers'],
          data: JSON.stringify(data),
          onUploadProgress: function onUploadProgress(progressEvent) {
            if (onProgress) {
              onProgress(progressEvent);
            }
          }
        }).then(function (response) {
          resolve(response.data);
        })["catch"](function (error) {
          if (error.response) {
            _Logger["default"].log('data', error.response);

            if (error.response.status === 403) {
              localStorage.removeItem('AUTH_TOKEN');
              window.location.replace('/login'); // store.dispatch(logoutTriggerAction());
            }

            if (error.response.status === 200) {
              var code = error.response.data.code;

              if (code === 401 || code === 403) {
                localStorage.removeItem('AUTH_TOKEN');
                window.location.replace('/login'); // store.dispatch(logoutTriggerAction())
              }
            }
          } else if (error.request) {// The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
          } else {// Something happened in setting up the request that triggered an Error
            }

          reject(error.response ? error.response.data : error);
        });
      });
    }
  }, {
    key: "guardedDownload",
    value: function () {
      var _guardedDownload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.call('tools/download/trigger', {
                  file: url
                });

              case 2:
                response = _context.sent;

                if (response.data.url) {
                  window.location = response.data.url;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function guardedDownload(_x) {
        return _guardedDownload.apply(this, arguments);
      }

      return guardedDownload;
    }()
  }]);

  return Api;
}();

exports["default"] = Api;